"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColorProvider = exports.ColorProviderProvider = exports.ClientColorProvider = void 0;
var react_1 = __importStar(require("react"));
var ColorProvider_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorProvider");
var WithColorFilterSubscription_1 = __importDefault(require("DreamCoat/WithColorFilterSubscription/WithColorFilterSubscription"));
var mobx_react_1 = require("mobx-react");
var ClientColorProvider = (function (_super) {
    __extends(ClientColorProvider, _super);
    function ClientColorProvider(allColors, _themeColors, _filteredThemeColors) {
        var _this = _super.call(this, { allColors: allColors }) || this;
        _this._themeColors = _themeColors;
        _this._filteredThemeColors = _filteredThemeColors;
        return _this;
    }
    Object.defineProperty(ClientColorProvider.prototype, "themeColors", {
        get: function () {
            return this._themeColors;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientColorProvider.prototype, "filteredThemeColors", {
        get: function () {
            return this._filteredThemeColors;
        },
        enumerable: false,
        configurable: true
    });
    return ClientColorProvider;
}(ColorProvider_1.ColorProvider));
exports.ClientColorProvider = ClientColorProvider;
var ColorProviderContext = (0, react_1.createContext)(undefined);
var ColorProviderProvider = function (_a) {
    var children = _a.children, brandStore = _a.brandStore, blockStore = _a.blockStore;
    return (react_1.default.createElement(FilteredBrandColorAdapter, { blockStore: blockStore, brandStore: brandStore }, function (_a) {
        var filteredBrandColors = _a.filteredBrandColors;
        return (react_1.default.createElement(ColorProviderContext.Provider, { value: new ClientColorProvider(brandStore.allColorsWithThemeIndex, brandStore.colorsWithThemeIndex, filteredBrandColors) }, children));
    }));
};
exports.ColorProviderProvider = ColorProviderProvider;
var useColorProvider = function () {
    var ctx = (0, react_1.useContext)(ColorProviderContext);
    if (!ctx) {
        throw new Error("Can only call useColorProvider inside a ColorProviderProvider context");
    }
    return ctx;
};
exports.useColorProvider = useColorProvider;
var FilteredBrandColorAdapter = (0, WithColorFilterSubscription_1.default)((0, mobx_react_1.observer)(function (_a) {
    var filteredColors = _a.filteredColors, children = _a.children;
    return children({ filteredBrandColors: filteredColors });
}));
